// extracted by mini-css-extract-plugin
export default {"error":"WSFormError-module_error-yPxeF","errorText":"WSFormError-module_errorText-wy1bb","errorIcon":"WSFormError-module_errorIcon-PAHyH"};